import { render, staticRenderFns } from "./AutoScaleOption.vue?vue&type=template&id=a7931654&scoped=true&"
import script from "./AutoScaleOption.vue?vue&type=script&lang=js&"
export * from "./AutoScaleOption.vue?vue&type=script&lang=js&"
import style0 from "./AutoScaleOption.vue?vue&type=style&index=0&id=a7931654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7931654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7931654')) {
      api.createRecord('a7931654', component.options)
    } else {
      api.reload('a7931654', component.options)
    }
    module.hot.accept("./AutoScaleOption.vue?vue&type=template&id=a7931654&scoped=true&", function () {
      api.rerender('a7931654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/AutoScaleOption.vue"
export default component.exports